export const MAX_DOCUMENT_MB_SIZE = 40;
export const BYTES_IN_MB = 1024 * 1024;

export const DEFAULT_FILE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "application/pdf",
];

export enum FileRejectionCode {
  FILE_TOO_LARGE = "file-too-large",
  FILE_TOO_SMALL = "file-too-small",
  FILE_INVALID_TYPE = "file-invalid-type",
  NETWORK_ERROR = "network-error",
}

export type DropError = keyof typeof FileRejectionCode | string;
